<template>
  <div>
    <div>
      <b-form-group label="PrimaryIP:" label-for="primary_ip">
        <b-form-input
          id="primary_ip"
          type="text"
          v-model="model.primary_ip"
          required
        >
        </b-form-input>
      </b-form-group>
      <b-form-group label="PrimaryPort:" label-for="primary_port">
        <b-form-input
          id="primary_port"
          type="number"
          v-model="model.primary_port"
          required
        >
        </b-form-input>
      </b-form-group>
      <b-form-group label="SecondaryIP:" label-for="secondary_ip">
        <b-form-input
          id="secondary_ip"
          type="text"
          v-model="model.secondary_ip"
          required
        >
        </b-form-input>
      </b-form-group>
      <b-form-group label="SecondaryPort:" label-for="secondary_port">
        <b-form-input
          id="secondary_port"
          type="number"
          v-model="model.secondary_port"
          required
        >
        </b-form-input>
      </b-form-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "CAS_ServerForm",
  props: ["model"],
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/CAS_ServerForm.vue